export default {
      id: "column-settings-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#column-settings-usage",
      toString: function () {
        return this.url;
      }
    }